import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';
import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';
import { isValidDate } from 'utils/isValidDate';

export const formatEnvelopeDate = (date: string | number | Date) => {
  if (isValidDate(date)) {
    return <>{format(new Date(date), DATE_FORMAT_WITH_TIME)}</>;
  }
  return <p className="text-sm text-muted mb-0">{translate('NotAvailable')}</p>;
};
